import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe, DOCUMENT } from '@angular/common';
import { CommonService } from 'app/_services/common.service'
import { VeteranCenterComponent } from './veteran-center/veteran-center.component';


@Component({
  selector: 'app-virtual-selection',
  templateUrl: './virtual-selection.component.html',
  styleUrls: ['./virtual-selection.component.css']
})
export class VirtualSelectionComponent implements OnInit {

 
  public selected;
  public siteDetails = [
    {site_id: 'site1', site_name: 'Site One'},
    {site_id: 'site2', site_name: 'Site two'}

  ];

  public taxPrepCenter = [
    {tpc_id : '1', tpc_name:"VLP" },
    {tpc_id : '2', tpc_name:"RMU" }

  ]

  public selectedCenter;
  public tpc_id;
  public tpc_name;
  VirtualSiteslist: any;
  URL: string;
  group_name: string;
  account_id: string;
  
  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.getAllVirtualSiteslist();
  }

  selectCategory(site_key, site_name, event) {
    // if (event.isUserInput) {

      this.selected = site_key;
      this.account_id = site_key;
      this.group_name = site_name;
      console.log('selected' ,this.account_id,"text",this.group_name);
    
    // }
  }

  
  selectCenter(selectedCenter,tpc_id,tpc_name,event) {
      this.selectedCenter = selectedCenter;
      this.tpc_id = tpc_id;
      this.tpc_name = tpc_name
  }


  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  getAllVirtualSiteslist(){
    this.commonService.getAllVirtualSites(Input).subscribe(res => {
      this.VirtualSiteslist = res.body.data;
      console.log(this.VirtualSiteslist, 'foodresp')
    })
  }
  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }
  name = 'World';
  dateFrom = '03-11-2016';
  page = 1;
  openDialog2(group_name1){
   // this.URL="https://www.getyourrefund.org/en",
    //this.router.navigate([this.URL, { dateFrom: this.dateFrom, page: this.page }]);
    
    this.URL="https://www.getyourrefund.org/en/"+this.selected+"/"+this.group_name;
   // this.account_id = site_id;
   
  //  this.selected = selected;
  //  this.account_id = site_id;

    console.log("Save button is clicked!",this.group_name); 
   // this.document.location.href = 'https://www.getyourrefund.org/en';
    window.open(this.URL+this.group_name, "_blank");
    console.log("Save button is clicked!",this.group_name); 
  }
  openDialog(action: any, obj: any, element: any) {
    const dialogConfig = new MatDialogConfig();
    obj.action = action;
    if (element != null) {
      obj.id = element;
    }
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = obj;
    let dialogRef;
    if (action === 'veteran') {
      dialogRef = this.dialog.open(VeteranCenterComponent, dialogConfig);
    }
    if (action === 'regular') {
      dialogRef = this.dialog.open(VeteranCenterComponent, dialogConfig);
    }
    
  
    dialogRef.afterClosed().subscribe(result => {
      // alert('response: ' + result)
      if (result.event === 'veteran' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'User added successful', 'announcement');
      }
      if (result.event === 'regular' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'User added successful', 'announcement');
      }
  
    });
  }
  showNotification(from, align, color, stringMessage, icons) {
    const type = ['', 'info', 'success', 'warning', 'danger'];
  
  
  
    // $.notify({
    //   icon: icons,
    //   message: stringMessage
  
    // }, {
    //   type: type[color],
    //   timer: 4000,
    //   placement: {
    //     from: from,
    //     align: align
    //   },
    //   template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
    //     '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
    //     '<i class="material-icons" data-notify="icon">notifications</i> ' +
    //     '<span data-notify="title">{1}</span> ' +
    //     '<span data-notify="message">{2}</span>' +
    //     '<div class="progress" data-notify="progressbar">' +
    //     '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
    //     '</div>' +
    //     '<a href="{3}" target="{4}" data-notify="url"></a>' +
    //     '</div>'
    // });
  }

}
